import React from "react";

export const Error = () => {
  return (
    <div>
      <h1>404</h1>
    </div>
  );
};
